module.exports = __webpack_public_path__ + "img/02-04-img-01.2f319c4e.png";